import React, { useState } from "react";
import { useAssessment } from "../../providers/AssessmentProvider";
import {
  Accordion,
  AccordionSummary,
  useTheme,
  useMediaQuery,
  Button,
  Typography,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { getAssessmentReviewPageStyle } from "../../components/customstyles/AssessmentReviewPageStyle";
import TextField from "@mui/material/TextField";
import ErrorDialog from "../../components/ErrorDialog";
import { useShowErrorDiaglog } from "../../providers/ShowErrorDiaglogProvider";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom";
import { Formik } from "formik";
import { recordCustomEvent } from "../../pinpointConfig";
import { useAssessmentWalkthrough } from "../../providers/AssessmentWalkthroughProvider";
import AssessmentWalkThroughDrawerHandler from "./AssessmentWalkThroughDrawerHandler";

const useStyles = () => {
  const theme = useTheme();
  return getAssessmentReviewPageStyle(theme);
};

const mapping = {
  0: "None",
  1: "Minimal",
  2: "Mild",
  3: "Moderate",
  4: "Severe",
};
const dentalMapping = {
  0: "Yes",
  1: "No",
};

function AssessmentReviewPage() {
  const styles = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width: 900px)");
  const [showWalkhThroughDrawer, setShowWalkhThroughDrawer] = useState(false);
  const { showOrHideBottomBar } = useAssessmentWalkthrough();
  const { assessment, handleAssessmentToggle, handleNotes } = useAssessment();
  const { showErrorDialog, headerText, openOrCloseErrorDialog } =
    useShowErrorDiaglog();

  const getSeverityName = (selectedSeverity) => {
    if (selectedSeverity === null) {
      return "Not Answered";
    } else {
      if (["Yes", "No"].includes(selectedSeverity)) {
        return selectedSeverity;
      } else {
        let value = mapping[selectedSeverity];
        return `${selectedSeverity} - ${value}`;
      }
    }
  };

  const getOptions = (section, selectedValue) => {
    let options = Object.values(
      section === "dentalStatus" ? dentalMapping : mapping
    ).map((severity, index) => {
      return {
        label: section === "dentalStatus" ? severity : `${index} - ${severity}`,
        value: section === "dentalStatus" ? severity : index,
        backgroundColor: selectedValue === index ? "#2196F30A" : "white",
      };
    });
    if (section !== "bodyAreas") {
      options.unshift({
        label: "Not Answered",
        value: null,
        backgroundColor: selectedValue === null ? "#2196F30A" : "white",
      });
    }
    return options;
  };

  const EditButtonComponent = ({
    section,
    selectedValue,
    questionIndex,
    subSection,
  }) => {
    const handleDropDownChange = (value) => {
      handleAssessmentToggle(section, subSection, questionIndex, value);
    };

    return (
      <Autocomplete
        disablePortal
        options={getOptions(section, selectedValue)}
        sx={{
          boxShadow: "none",
          border: 0,
          ".MuiOutlinedInput-notchedOutline": { border: 0 },
          "& .MuiInputLabel-root": styles.editButtonText,
        }}
        onChange={(event, value) => handleDropDownChange(value.value)}
        value={null}
        renderInput={(params) => {
          return <TextField {...params} label="Edit" />;
        }}
        componentsProps={{
          paper: {
            sx: {
              width: 200,
            },
          },
        }}
        renderOption={(props, option) => {
          const { label, backgroundColor } = option;
          return (
            <span {...props} style={{ backgroundColor: backgroundColor }}>
              {label}
            </span>
          );
        }}
      />
    );
  };
  const history = useHistory();
  const params = useParams();
  const handleBackToPatientClick = () => {
    const { patientId } = params;
    openOrCloseErrorDialog(false);
    history.push({
      pathname: `/patients/${patientId}`,
    });
  };

  const handleNotesInput = (section, subSection, value) => {
    handleNotes(section, subSection, value);
  };
  const handleWalkThroughDrawer = (key) => {
    setShowWalkhThroughDrawer(key);
    if (isMobile) {
      showOrHideBottomBar(key !== null ? true : false);
    }
  };

  const updatePinpointEvent = (key) => {
    recordCustomEvent(window.location.pathname + `/${key}`);
  };
  return (
    <>
      {showErrorDialog && (
        <ErrorDialog HeaderText={headerText} dismiss={""}>
          <Button
            primary
            sx={theme.customErrorDialog}
            onClick={handleBackToPatientClick}
          >
            Take Me To Patient Page
          </Button>
        </ErrorDialog>
      )}
      <div
        className="FSUnmask"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <div
          style={{
            marginTop: isMobile ? "90px" : "0px",
            width: "760px",
            paddingTop: isMobile ? "20px" : "100px",
            paddingBottom: isMobile ? "20px" : "100px",
            backgroundColor: "#f7f9fa",
          }}
        >
          <div style={{ ...styles.assessmentReviewHeading }}>
            <Typography fontSize={30}>Assessment Review</Typography>
          </div>
          <div
            style={{
              padding: "20px",
            }}
          >
            {Object.values(assessment).map((section, index) => {
              return (
                <>
                  <Accordion
                    defaultExpanded
                    style={{
                      backgroundColor: "transparent",
                      boxShadow: "none",
                    }}
                  >
                    {section.key === "bodyAreas" && (
                      <AccordionSummary
                        className="FSUnmask"
                        aria-controls="panel1-content"
                        id="panel1-header"
                        style={{
                          fontSize: "24px",
                          color: "black",
                          padding: "0px",
                          cursor: "default",
                        }}
                      >
                        <Typography fontSize={24} padding={0}>
                          {section.sectionName}
                        </Typography>
                      </AccordionSummary>
                    )}

                    {section.sectionAssessment.map((item, itemIndex) => {
                      return (
                        <div>
                          <div style={{ ...styles.subSectionHeadingContainer }}>
                            <div
                              style={{
                                ...styles.subSectionHeadingTextContainer,
                              }}
                            >
                              <h2
                                style={{
                                  ...styles.subSectionHeadingTextContainer.h2,
                                }}
                              >
                                {item.name}
                              </h2>
                              <div
                                style={{ ...styles.subSectionInfoContainer }}
                                onClick={() => {
                                  updatePinpointEvent(
                                    `${
                                      section === item.key ? "" : section + "/"
                                    }${item.key}/whatsthis`
                                  );
                                  handleWalkThroughDrawer(item.key);
                                }}
                              >
                                <h3
                                  style={{
                                    fontSize: "15px",
                                    fontWeight: "400",
                                    margin: 0,
                                  }}
                                >
                                  What's This?
                                </h3>
                                <InfoOutlinedIcon fontSize="15px" />
                              </div>
                            </div>
                          </div>
                          <div style={{ ...styles.questionsContainer }}>
                            {item.questions.map((question, index) => {
                              let selectedValue;
                              if (question.selectedValue !== undefined) {
                                selectedValue = question.selectedValue;
                              } else {
                                selectedValue = null;
                              }
                              return (
                                <div
                                  style={{ ...styles.questionsTextContainer }}
                                >
                                  <p
                                    style={{
                                      width: "100%",
                                      color: "black",
                                    }}
                                  >
                                    {index + 1}. {question.title}
                                  </p>
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: 10,
                                      alignItems: "center",
                                    }}
                                  >
                                    <p
                                      style={{
                                        width: "100px",
                                        textAlign: "center",
                                      }}
                                    >
                                      {`${getSeverityName(selectedValue)}`}
                                    </p>
                                    <EditButtonComponent
                                      section={section.key}
                                      selectedValue={selectedValue}
                                      questionIndex={index}
                                      subSection={itemIndex}
                                    />
                                  </div>
                                </div>
                              );
                            })}
                            <div
                              style={{
                                margin: "20px 0px",
                              }}
                            >
                              <hr style={{ ...styles.horizonalLine }} />
                            </div>

                            <Formik
                              initialValues={{
                                notes:
                                  item.notes !== undefined ? item.notes : "",
                              }}
                            >
                              {({ values }) => (
                                <form>
                                  <TextField
                                    sx={{
                                      "& .MuiOutlinedInput-root": {
                                        "&.Mui-focused fieldset": {
                                          borderColor: "#1E88E5", // Change border color when focused
                                        },
                                      },
                                      "& .MuiOutlinedInput-input": {
                                        padding: 0, // Set padding to 0
                                      },
                                    }}
                                    maxRows={4}
                                    multiline
                                    fullWidth
                                    id="outlined-basic"
                                    label="Notes"
                                    variant="outlined"
                                    defaultValue={values.notes}
                                    onInput={(event) => {
                                      handleNotesInput(
                                        section.key,
                                        itemIndex,
                                        event.target.value
                                      );
                                    }}
                                  />
                                </form>
                              )}
                            </Formik>
                          </div>
                        </div>
                      );
                    })}
                  </Accordion>
                  {index < Object.values(assessment).length - 1 ? (
                    <hr style={{ ...styles.horizonalLine }} />
                  ) : (
                    <></>
                  )}
                </>
              );
            })}
          </div>
        </div>
        {Object.values(assessment).map((section) => {
          return (
            <>
              {section["sectionAssessment"].map((item, index) => {
                return (
                  <AssessmentWalkThroughDrawerHandler
                    item={item}
                    index={index}
                    isMobile={isMobile}
                    handleWalkThroughDrawer={handleWalkThroughDrawer}
                    showWalkhThroughDrawer={showWalkhThroughDrawer}
                  />
                );
              })}
            </>
          );
        })}
      </div>
    </>
  );
}

export default AssessmentReviewPage;
